import React, { PureComponent } from 'react';
import _ from 'lodash';
import { Slider, Image } from '../components';
import { withRedux } from '../hoc';
import { getServiceUrl } from '../utils';

const mapStateToProps = state => {
  return {
    t: _.get(state, 't'),
    languages: _.get(state, 'languages')
  };
};

const actions = {};

@withRedux(mapStateToProps, actions)
export default class MainSlider extends PureComponent {
  render() {
    const mainSlide = _.get(this.props, 'data');
    if (_.size(mainSlide) === 0) return null;
    return (
      <div className="main-slider-component">
        <Slider
          settings={{
            adaptiveHeight: true,
            autoplaySpeed: 5000,
            autoplay: true,
            responsive: [
              {
                breakpoint: 991,
                settings: {
                  dots: false,
                  arrows: false
                }
              }
            ]
          }}
          items={mainSlide}
          uiRenderer={media => {
            if (_.isEmpty(media)) return null;
            const link = _.get(media, 'link');
            const type = _.get(media, 'media_image_data.type');
            // const full_file_path = _.get(media, "media_image_data.full_file_path");
            const full_file_path = `${getServiceUrl()}/${_.get(media, 'media_image_data.path')}`;
            let mediaHtml = null;
            if (_.includes(type, 'video')) {
              mediaHtml = (
                // <video src={full_file_path} alt={process.env.REACT_APP_WEBSITE_NAME} controls autoplay />
                <video src={full_file_path} alt={process.env.REACT_APP_WEBSITE_NAME} controls autoplay />
              );
            } else if (_.includes(type, 'image')) {
              mediaHtml = <Image src={full_file_path} alt={process.env.REACT_APP_WEBSITE_NAME} />;
            }
            if (link)
              mediaHtml = (
                <a href={link} target="_blank">
                  {mediaHtml}
                </a>
              );
            return mediaHtml;
            // return <div className="media-style">{mediaHtml}</div>;
          }}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/MainSlider.js